import EventTypeComponent from '../../shared/components/EventTypes/EventTypeComponent';
import NotificationMap from '../../shared/components/NotificationMap/NotificationMap';
import TimeSpans from '../../shared/components/TimeSpans/TimeSpans';
import ConfirmationScreen from '../components/ConfirmationScreen';

export const steps = [
  {
    label: 'When do you want to receive notifications?',
    description: `Define times during the day when you would want to receive email notifications of traffic incidents. 
      You may create multiple alert periods, but at least one must be defined in order to receive notifications.`,
    component: TimeSpans,
  },
  {
    label: 'What types of notifications would you like to receive?',
    description: `Select the event types and impact levels for which you want to receive alerts.`,
    component: EventTypeComponent,
  },
  {
    label: 'What areas would you like to receive notifications for?',
    description: `Define regions for which you would like to receive notifications.
        You may create up to 15 regions, but at least one must be defined in order to receive notifications.`,
    component: NotificationMap,
  },
  {
    label: 'Profile Complete',
    description: ``,
    component: ConfirmationScreen,
  },
];
